<template>
    <li
        role="button"
        tabindex="0"
        class="w-full cursor-pointer rounded text-lg text-theme-text transition focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500"
        @click.stop="goToItem(item)"
    >
        <Row :class="['items-first', 'px-3', 'py-0.5', 'rounded', 'rounded', { 'font-bold': isFolder }]">
            <LayoutCol span="10" dusk="itemContentList">
                {{ item.label }}
            </LayoutCol>
            <LayoutCol v-if="item.page" span="2" dusk="itemPage" class="text-right">
                {{ item.page }}
            </LayoutCol>
        </Row>
        <ul class="pl-1">
            <content-list v-for="(childItem, index) in item.items" :key="index" :item="childItem" dusk="subItem" />
        </ul>
    </li>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'ContentList',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters(['isEpub', 'isPreviewMode']),
        isFolder() {
            return this.item.items && this.item.items.length;
        },
    },
    methods: {
        ...mapActions(['goToPage', 'goToLocation', 'toggleTableOfContents']),
        goToItem(item) {
            if (this.isPreviewMode) {
                return false;
            }

            this.isEpub ? this.goToLocation({ chapterHref: item.chapterHref }) : this.goToPage({ page: item.page });

            this.toggleTableOfContents();
        },
    },
};
</script>
<style scoped>
li:hover > div {
    @apply bg-gray-100 dark:bg-gray-600;
}
</style>
